import { render, staticRenderFns } from "./foodunitdetails.vue?vue&type=template&id=3cb60762&scoped=true&"
import script from "./foodunitdetails.vue?vue&type=script&lang=js&"
export * from "./foodunitdetails.vue?vue&type=script&lang=js&"
import style0 from "./foodunitdetails.vue?vue&type=style&index=0&id=3cb60762&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb60762",
  null
  
)

export default component.exports